import { keepPreviousData } from "@tanstack/react-query";

import { useFetchQuery } from "common/queries/hooks";
import { IPaginatedQuery } from "common/types";

import { PrescriptionList, PrescriptionsSearch } from "../types";
import { keys, urls } from "./constants";

export const usePrescriptionsQuery = (
  search: PrescriptionsSearch = {},
  { enabled = true }: { enabled?: boolean } = {},
) => {
  return useFetchQuery<IPaginatedQuery<PrescriptionList>, PrescriptionsSearch>(
    keys.prescriptionList(search),
    {
      fetch: { url: urls.prescriptions(), body: search },
      config: {
        placeholderData: keepPreviousData,
        enabled,
      },
    },
  );
};
